import autobind from 'class-autobind';

import EventTarget from '@/util/EventTarget.js'
import { findUpTagByClass } from '@/util/findUpTag.js'


export default class MarqueeHandler {
    constructor(host) {
        autobind(this);

        this.host = host;
    }

    tap(event) {
    }

    startdrag(event) {
    }

    enddrag(event) {
    }
};